<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  const slug = 'mapbox-hotspots';
  export let selectedValue = 'hotspots';

  export let buttonList = [
    { label: 'Hot spots', value: 'hotspots' },
    { label: 'Cumulative', value: 'totals' },
  ];

  $: dispatch('active', selectedValue);
</script>

{#if buttonList.length > 1}
<div class="button-grid-buttons">
  {#each buttonList as obj}
    <button
      name={slug}
      class="toggle {obj.value === selectedValue ? 'active' : 'inactive'}"
      on:click={() => (selectedValue = obj.value)}
    >
      {obj.label}
    </button>
  {/each}
</div>
{/if}